import { render, staticRenderFns } from "./GinViewcon.vue?vue&type=template&id=2a53b3cc&scoped=true"
import script from "./GinViewcon.vue?vue&type=script&lang=js"
export * from "./GinViewcon.vue?vue&type=script&lang=js"
import style0 from "./GinViewcon.vue?vue&type=style&index=0&id=2a53b3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53b3cc",
  null
  
)

export default component.exports